






































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import Paging from 'biz-ts/src/api/Paging';
import deviceModule from "@/store/module/DeviceModule";
import PaginationTable from "@/component/Table/pagination-table.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import DeviceTaskGenApi from "@/module/device/DeviceTaskGenApi";
import {DtaskGenPqForm} from '@/form/DeviceTaskForm'
import DeviceTaskGenerator from "@/model/DeviceTaskGenerator";
import {timesZh} from '@/model/TaskGenerator';
import _ from 'lodash';
import DeleteDialog from "@/component/Crud/delete-dialog.vue";

@Component({
  components: {
    PaginationTable,
    RefreshButton,
    DeleteDialog,
  },
})
export default class DeviceTaskGeneratorView extends Vue {

  private dtaskGenApi = Container.get(DeviceTaskGenApi)

  @Ref()
  private ptable!: PaginationTable

  private get device() {
    return deviceModule.active
  }

  private dtgen = new DeviceTaskGenerator()

  private paging = new Paging<DeviceTaskGenerator>()
  private pqForm = new DtaskGenPqForm(
      this.device.id
  )

  private async getPaging() {
    return this.dtaskGenApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private timesZh = timesZh

  private timesFmt(tgen: DeviceTaskGenerator) {
    return this.timesZh[tgen.times]
  }

  private leftTimeToNextFmt(tgen: DeviceTaskGenerator) {
    const leftTime = tgen.leftTimeToNext
    const arr = _.split(leftTime, ' ')
    const days = arr[0]
    const time = arr[1]
    if (days == '0')
      return time
    else return leftTime
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private enable(dtaskGen: DeviceTaskGenerator) {
    this.dtaskGenApi.enable({
      id: dtaskGen.id,
      enabled: dtaskGen.enabled
    })
  }

  private async handleDeleteClick(dtgen: DeviceTaskGenerator) {
    this.dtgen = dtgen
    this.deleteDialog.open()
  }

  private async deleteDtgen() {
    await this.dtaskGenApi.delete(this.dtgen.id)
  }
}
